import { render, staticRenderFns } from "./IconColumnTemplateComponent.vue?vue&type=template&id=d7a14734&lang=pug"
import script from "./IconColumnTemplateComponent.vue?vue&type=script&lang=ts"
export * from "./IconColumnTemplateComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7a14734')) {
      api.createRecord('d7a14734', component.options)
    } else {
      api.reload('d7a14734', component.options)
    }
    module.hot.accept("./IconColumnTemplateComponent.vue?vue&type=template&id=d7a14734&lang=pug", function () {
      api.rerender('d7a14734', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/grids/ColumnTemplates/IconColumnTemplateComponent.vue"
export default component.exports